module.exports = __webpack_public_path__ + "static/media/noun_auction_1658111.cb1d1a2c.svg";